var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgreementModalWrapper',_vm._b({ref:"modal",staticClass:"modal",attrs:{"agreement":null,"title":null}},'AgreementModalWrapper',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }